module.exports = "/_next/static/images/gift-ea31862a849a67012cbeda561e15258c.png";